import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds,
} from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { IdealWeight_EndPoint } from "./ConstantsHealthCalculator";
import IdealWeightTable from "./IdealWeightTable";
import SharedHelmet from "../Helmet";
const TITLE = "حساب الوزن المثالي - تحديد الوزن الصحي بناء على الطول";
const DESCRIPTION =
  "حساب الوزن المثالي للطول الخاص بك باستخدام حاسبة الوزن المثالي  - اكتشف الوزن المناسب لجسمك من خلال استخدام هذه الحاسبة السهلة والموثوقة. يمكنك حساب الوزن المثالي للنساء والرجال على حد سواء.";
const KEYWORDS =
  "كيفية حساب الوزن المثالي, حساب كتلة الجسم, حساب الوزن المناسب للطول والعمر, حاسبة الوزن المثالي, حساب BMI, حساب الوزن المثالي للطول, حساب الوزن المثالي حسب الطول, اهمية الوزن المثالي للصحة";
const OG_URL = "https://do-calculate.com/calculator/ar/idealweight/";
const apiEndpoint = `${SERVER_URL}/${IdealWeight_EndPoint}`;
function IdealWeightCalculator() {
  const [height, setHeight] = useState("");
  const [gender, setGender] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const calculateIdealWeight = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ height, gender }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                هل ترغب في معرفة وزنك المثالي؟ استخدم حاسبة الوزن المثالي لتحصل
                على الوزن الذي يُعتبر مثاليًا لصحتك ولياقتك البدنية بناءً على
                طولك وجنسك. توفر الحاسبة حسابًا دقيقًا ل حساب الوزن المثالي -
                حساب الوزن مثالي للطول - حساب الوزن المثالي للرجل - حساب الوزن
                المثالي للنساء.
                <br /> ستقوم الحاسبة بعد ذلك بحساب الوزن المثالي للطول والوزن
                المثالي لكل حالة بناءً على الجنس المحدد (مثل الوزن المثالي للطول
                160 أو 165).
                <br />
                حساب الوزن المثالي يُعتبر مفتاحاً هاماً للحفاظ على الصحة
                واللياقة البدنية. استخدم الحاسبة الآن واحصل على النتيجة بسرعة
                وسهولة. قم بمحاولة حساب الوزن المثالي للرجل أو حساب الوزن
                المثالي للنساء أو حساب الوزن المثالي حسب الطول أو حساب الوزن
                المثالي حسب العمر وتحقق من وزنك المثالي الآن!
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  الوزن المثالي
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="height" className="form-label ms-2">
                      الطول
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">سم</span>
                  </div>
                </div>
                <br />                <div className="form-group d-flex align-items-center">
                  <b>
                    <label >الجنس</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      value="male"
                      id="male"
                      checked={gender === "male"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="male">
                      ذكر
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      value="female"
                      id="female"
                      checked={gender === "female"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="female">
                      أنثى
                    </label>
                  </div>
                </div>
                <br />
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateIdealWeight}
                  disabled={isLoading}
                >
                  إحسب
                </button>
              </div>
              <div className="col-12 col-md-7">
                {result && (
                  <div>
                    <div className="alert alert-success">
                      <h5>النتائج : </h5>
                    </div>
                    <hr />
                    <IdealWeightTable result={result}></IdealWeightTable> <br />
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-auto">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> حدث خطأ :</u>
                    </b>{" "}
                    يُرجى إدخال جميع الحقول بالشكل الصحيح.{" "}
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"> {TITLE}</div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    الوزن المثالي: كل ما تحتاج لمعرفته حول الوزن المثالي وكيفية
                    حسابه
                  </h2>{" "}
                </u>
                <p>
                  الوزن المثالي هو مصطلح يثير اهتمام الكثيرين، ولكن ما هو
                  بالضبط؟ الوزن المثالي هو الوزن الذي يعتبر أفضل وزن لصحتك
                  العامة بناءً على ارتفاعك وعمرك وجنسك. إن معرفة الوزن المثالي
                  لك يمكن أن يكون خطوة مهمة نحو العيش بحياة صحية ونشطة. في هذه
                  المقالة، سنلقي نظرة على كيفية حساب الوزن المثالي وأهميته
                  للصحة.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    الوزن المثالي للرجال والنساء:
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  الوزن المثالي يختلف بين الرجال والنساء. بشكل عام، يكون الوزن
                  المثالي للنساء أقل قليلاً من الرجال نظرًا لاختلافات الجسم
                  والتركيب البيولوجي. لذا، من الضروري مراعاة هذه الاختلافات عند
                  تحديد الوزن المثالي الخاص بك.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    كيفية حساب الوزن المثالي:
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  تعتبر السعرات الحرارية من أهم المفاهيم في عالم التغذية والصحة.
                  إن معرفة كمية السعرات الحرارية التي يحتاجها جسمك يمكن أن يكون
                  مفتاحًا لتحقيق التغذية السليمة والحفاظ على وزن صحي. في هذه
                  المقالة، سنتعرف على كيفية حساب السعرات الحرارية التي يحتاجها
                  جسمك وأهميتها في الحفاظ على صحتك.
                </p>
                نستخدم في هذه الحاسبة4 معادلات مختلفة لحاسب الوزن المثالي:
                <br />
                <div>
                  <b> G. J. Hamwi Formula (1964)</b>
                  <br />
                  الصيغة تقترب كثيرًا من تقديم نطاق مقبول. ومع ذلك، لم تكن عملية
                  انتشارها مكثفة مثل حالة ديفين. وقد تم انتقاد ذلك كثيرًا من قبل
                  النقاد الذين يؤكدون أن العديد من الأشخاص الذين يستخدمون الوزن
                  المثالي لا يتقبلون التغييرات بسهولة.<u>تحسب كالتالي:</u>{" "}
                  <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>
                        ذكور : الوزن المثالي للجسم (بالكيلوجرام) = 48 كجم + 2.7
                        كجم لكل سنتيمتر فوق 152 سم
                      </li>
                      <li>
                        إناث : الوزن المثالي للجسم (بالكيلوجرام) = 45.5 كجم +
                        2.2 كجم لكل سنتيمتر فوق 152 سم
                      </li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> B. J. Devine Formula (1974)</b>
                  <br />
                  في نهجه، أوضح ديفين أن رجلاً بارتفاع 5 أقدام (152 سم) يجب أن
                  يكون وزنه 50 كيلوجرامًا، في حين يجب أن يكون وزن امرأة بارتفاع
                  5 أقدام (152 سم) 45.5 كيلوجرام. وبالنسبة لكل قدم إضافية، يجب
                  ضبط الوزن المثالي للجسم بمقدار 2.3 كيلوجرام.
                  <u>تحسب كالتالي:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>للذكور: 50.0 كجم + 2.3 كجم لكل سنتيمتر فوق 152 سم</li>
                      <li>للإناث: 45.5 كجم + 2.3 كجم لكل سنتيمتر فوق 152 سم</li>
                    </ul>
                  </div>
                </div>
                <div>
                  <b> J. D. Robinson Formula (1983)</b>
                  <br />
                  في صيغته، أخذ روبنسون صيغة ديفين وخضعها للبيانات التجريبية.
                  وجد أن الرقم الأساسي للوزن المثالي للجسم يختلف وقام أيضًا
                  بمراجعة التعديل للأشخاص الذين يزيد طولهم عن 5 أقدام (152 سم).
                  <u>تحسب كالتالي:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>للذكور: 52 كجم + 1.9 كجم لكل سنتيمتر فوق 152 سم</li>
                      <li>للإناث: 49 كجم + 1.7 كجم لكل سنتيمتر فوق 152 سم</li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> D. R. Miller Formula (1983)</b>
                  <br />
                  تستخدم صيغة ميلر لاحتساب الوزن المثالي للجسم اعتمادًا على
                  الطول. تمامًا مثل الصيغ الأخرى المذكورة أعلاه، لم يُدرج في
                  صيغة ميلر العوامل الهامة التي تسهم في التغيرات في وزن الجسم.
                  <u>تحسب كالتالي:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>
                        للذكور: 56.2 كجم + 1.41 كجم لكل سنتيمتر فوق 152 سم
                      </li>
                      <li>
                        للإناث: 53.1 كجم + 1.36 كجم لكل سنتيمتر فوق 152 سم
                      </li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> نطاق صحي لمؤشر كتلة الجسم </b>
                  <br />
                  المنظمة العالمية للصحة (WHO) توصي بنطاق صحي لمؤشر كتلة الجسم
                  (BMI) يتراوح بين 18.5 و 25 لكلا الذكور والإناث. بناءً على نطاق
                  BMI، يمكن معرفة الوزن الصحي لأي طول محدد.
                  <br />
                  مؤشر كتلة الجسم (BMI) هو مقياس يستخدم على نطاق واسع لتحديد
                  الوزن المثالي للجسم. يُستخدم على نطاق واسع في المجال الطبي
                  كمؤشر سريع للمضاعفات الصحية المحتملة. عمومًا، كلما ارتفع مؤشر
                  كتلة الجسم، زادت فرصة حدوث مشاكل صحية مثل السمنة والسكري
                  وأمراض القلب وغيرها. يُستخدم كمؤشر من قبل الأطباء لتقديم نصائح
                  صحية للمرضى بشأن المشاكل الصحية المحتملة، خاصة إذا كان هناك
                  زيادة تدريجية ملحوظة في مؤشر كتلة الجسم، وهو المقياس الرسمي
                  الحالي لتصنيف الأفراد حسب مستويات السمنة المختلفة.
                </div>
                <br />
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    اهمية الوزن المثالي للصحة:
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  {" "}
                  الوزن المثالي له تأثير كبير على صحتك. إذا كنت تعاني من زيادة
                  غير طبيعية في الوزن، فإن ذلك يمكن أن يزيد من خطر الإصابة
                  بالعديد من الأمراض مثل أمراض القلب والسكري وارتفاع ضغط الدم.
                  من ناحية أخرى، إذا كنت تحت الوزن المثالي، فقد تكون عرضة لمشاكل
                  صحية مثل هشاشة العظام ونقص التغذية.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}> ختاماً: </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  الوزن المثالي ليس مجرد رقم على الميزان. إنه يعتمد على العديد
                  من العوامل الشخصية بما في ذلك الارتفاع، والعمر، والجنس، والهدف
                  الصحي. يجب دائمًا استشارة الطبيب أو محترف الرعاية الصحية قبل
                  اتباع أي حمية أو برنامج للوزن لضمان تحقيق أهدافك بشكل آمن
                  وصحي. باستخدام هذه المعلومات والأدوات البسيطة مثل حساب BMI
                  والصيغ الأخرى، يمكنك العمل على تحديد الوزن المثالي الذي يناسبك
                  ويساهم في تحسين صحتك وجودتك العامة للحياة.
                </p>
                <hr />
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>اسئلة متكررة</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>كم يزن جسدك ؟</h3>
              </div>
              <div className="info-section-body">
                الدم في جسمك يزن حوالي 7% من وزنك الإجمالي.
                <br />
                عظامك 15%
                <br />
                عضلاتك تتراوح بين 25 و 50% من وزن جسمك.
                <br />
                النسبة المئوية للدهون يمكن أن تكون أي شيء من 6% (للرجال
                الرياضيين) إلى 31% للنساء (متوسط) و24% للرجال (أيضًا متوسط).
                <br />
                عندما تصل نسبة الدهون في جسمك إلى أكثر من 32% للنساء و25%
                للرجال، يعتبر أنك تعاني من السمنة. ولكن بالنظر إلى أن العضلات
                تشكل نسبة كبيرة من وزنك المحتمل، فمن الواضح أن الرقم الذي تراه
                على الموازين ليس بالضرورة الرقم الأفضل للإعتماد عليه، خاصة إذا
                كنت تمارس التدريبات المكثفة أو التدريبات بالمقاومة بانتظام.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>ماذا يعني الوزن الصحي؟</h3>
              </div>
              <div className="info-section-body">
                الوزن الصحي يعني أن لديك توازن صحي بين الدهون والعضلات والعظام،
                لذلك قد يكون ذلك مختلفًا قليلاً بالنسبة لكل شخص. على سبيل
                المثال، استنادًا إلى التركيب الوراثي الخاص بك، قد يختلف 'الوزن
                الصحي' الخاص بك عن الإرشادات الصحية الموصى بها من الحكومة.
                <br />
                إذا كان لديك إطار صغير مع وزن زائد كبير، فقد يتم اعتبارك ضمن
                نطاق الوزن الصحي فقط لأن إطارك الصغير يعوض الرقم.
                <br />
                بالمثل، إذا كنت تمتلك عظامًا كبيرة، فقد يؤثر ذلك أيضًا على الرقم
                الذي تراه على الموازين بحيث يبدو أن لديك وزن زائد أكثر مما هو
                عليه.
                <br />
                إلى جانب ذلك، يبدو أن هناك اختلافات في كيفية تأثير التركيب
                الوراثي على وزننا. أظهرت الأبحاث التي نشرت في المجلة الدولية
                للسمنة أن العلاقة بين نسبة الدهون في الجسم ومؤشر كتلة الجسم
                (BMI) في بعض الجماعات العرقية كانت مختلفة عن غيرها، مما يشير إلى
                أن أساليب التحقق من 'الوزن المثالي' قد تحتاج إلى تعديل اعتمادًا
                على التركيب الوراثي الخاص بك.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>كم يجب أن أزن؟</h3>
              </div>
              <div className="info-section-body">
                الوزن المثالي للشخص ليس قاعدة دقيقة. إنه يعتمد بشكل كبير على كل
                فرد. حتى الآن، لا يوجد قياس، سواء كان IBW أو مؤشر كتلة الجسم
                (BMI) أو غيره من القياسات، يمكن أن يحدد بشكل نهائي كم يجب أن يزن
                الشخص ليكون صحيًا. إنها مراجع فقط، والأهم من ذلك هو التمسك
                باتخاذ خيارات حياة صحية مثل ممارسة الرياضة بانتظام، وتناول
                مجموعة متنوعة من الأطعمة غير المعالجة، والحصول على قسط كاف من
                النوم، وما إلى ذلك، بدلاً من مطاردة وزن معين استنادًا إلى صيغة
                عامة.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف يؤثر العمر على الوزن المثالي؟
                </h3>
              </div>
              <div className="info-section-body">
                في نظرية، لا ينبغي أن يكون العمر عاملًا كبيرًا في الوزن المثالي
                بعد سن 14-15 للفتيات و16-17 للفتيان، بعد ذلك يتوقف معظم الأشخاص
                عن النمو. من المتوقع أن يفقد الذكور والإناث البشر 1.5 و2 بوصة في
                الطول على التوالي بحلول سن الـ 70. من المهم أن نتذكر أنه مع تقدم
                الأشخاص في العمر، ينخفض العضلات الهزيلة ويصبح من الأسهل تجميع
                الدهون الزائدة في الجسم. هذه عملية طبيعية، على الرغم من أنه من
                الممكن التقليل من آثار الشيخوخة من خلال اعتماد عادات مختلفة مثل
                مراقبة النظام الغذائي، وممارسة الرياضة، والتحكم في التوتر، وضمان
                النوم الكافي.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف يؤثر الجنس على الوزن المثالي؟
                </h3>
              </div>
              <div className="info-section-body">
                بشكل عام، تزن الإناث أقل من الذكور على الرغم من أنهن عادة ما
                يكون لديهن نسبة أعلى من الدهون في الجسم بشكل طبيعي. يحمل جسم
                الذكور عمومًا كتلة عضلية أكبر، والعضلات أثقل من الدهون. بالإضافة
                إلى ذلك، يكون الإناث عادة أقل كثافة عظمية. وأخيرًا وليس آخرًا،
                يميل الذكور إلى أن يكونوا أطول من الإناث.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف يؤثر الطول على الوزن المثالي؟
                </h3>
              </div>
              <div className="info-section-body">
                كلما زاد طول الشخص، زادت كتلة العضلات والدهون في جسمه، مما ينتج
                عنه وزنًا أكبر. الذكر على نفس الارتفاع مع الأنثى يجب أن يكون
                وزنه حوالي 10-20% أثقل.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف يؤثر حجم هيكل الجسم على الوزن المثالي؟
                </h3>
              </div>
              <div className="info-section-body">
                حجم هيكل الجسم هو عامل آخر يمكن أن يؤثر بشكل كبير على قياس الوزن
                المثالي. يتم تصنيف حجم هيكل الجسم عادة على أنه صغير، متوسط، أو
                كبير العظم. يتم قياسه بناءً على محيط المعصم بالنسبة للطول. إليك
                كيفية تصنيف حجم هيكل الجسم: للنساء: - الطول أقل من 5'2": - صغير
                العظم = محيط المعصم أقل من 5.5 بوصة - متوسط ​​العظم = محيط
                المعصم 5.5 بوصة إلى 5.75 بوصة - كبير العظم = محيط المعصم أكثر من
                5.75 بوصة - الطول بين 5'2" و 5'5": - صغير العظم = محيط المعصم
                أقل من 6 بوصة - متوسط ​​العظم = محيط المعصم 6 بوصة إلى 6.25 بوصة
                - كبير العظم = محيط المعصم أكثر من 6.25 بوصة - الطول أكثر من
                5'5": - صغير العظم = محيط المعصم أقل من 6.25 بوصة - متوسط
                العظم = محيط المعصم 6.25 بوصة إلى 6.5 بوصة - كبير العظم = محيط
                المعصم أكثر من 6.5 بوصة للرجال: - الطول أكثر من 5'5": - صغير
                العظم = محيط المعصم 5.5 بوصة إلى 6.5 بوصة - متوسط ​​العظم = محيط
                المعصم 6.5 بوصة إلى 7.5 بوصة - كبير العظم = محيط المعصم أكثر من
                7.5 بوصة شخص لديه هيكل عظمي كبير سيكون وزنه طبيعيًا أثقل من شخص
                لديه هيكل عظمي صغير، حتى عند نفس الطول، مما يجعل حجم هيكل الجسم
                عاملًا يمكن أن يؤثر على القياسات مثل الوزن المثالي ومؤشر كتلة
                الجسم (BMI).
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هي تأثيرات الصحة على الوزن غير الصحي للنساء؟
                </h3>
              </div>
              <div className="info-section-body">
                الوزن النقصي، الزائد، والسمنة يزيدون من مخاطرك للعديد من مشاكل
                الصحة الجادة:
                <br />
                - مشاكل دورة الحيض. فقدان الوزن الزائد يمكن أن يؤدي إلى انقطاع
                الحيض أو جعلها غير منتظمة.
                <br />
                - هشاشة العظام. الوزن النقصي يزيد من خطر إصابتك بمرض هشاشة
                العظام، وهو حالة تجعل العظام ضعيفة وسهلة التكسر.
                <br />- الاكتئاب. تشير الدراسات إلى أن الاكتئاب أكثر شيوعًا في
                النساء اللواتي يعانين من نقص الوزن مقارنة بالنساء اللواتي يتمتعن
                بوزن صحي.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هي بعض النصائح لفقدان الوزن بنجاح؟
                </h3>
              </div>
              <div className="info-section-body">
                مدى سرعة زيادة الوزن أو فقدانه يمكن أن يكون مختلفًا تمامًا من
                شخص لآخر بناءً على جيناتهم الخاصة، والأساليب البيولوجية،
                والماضي. جرب بعض أو كل النصائح التالية لمساعدتك:
                <br />
                - حدد أهدافًا واقعية. تحدث مع طبيبك أو ممرضتك حول أهدافك وكيفية
                تحقيقها.
                <br />
                - قم بتخطيط وجباتك مسبقًا، وطهي المزيد في المنزل.
                <br />- التركيز على تناول الأطعمة الصحية. الحصول على السعرات
                الحرارية بشكل رئيسي من البروتين النباتي، والحبوب الكاملة،
                والفواكه والخضروات قد يساعدك في فقدان الوزن بشكل آمن.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>كيف يؤثر الوزن على الصحة؟</h3>
              </div>
              <div className="info-section-body">
                إذا كنتما سمينين أو سمينات، فقد تزيد خطورتكما على تطوير مشاكل
                صحية مرتبطة بهذا الوزن. تشمل هذه الحالات مثل:
                <br />
                - أمراض القلب الناجمة عن الشرايين الجلدية.
                <br />
                - ارتفاع ضغط الدم.
                <br />
                - السكتة الدماغية.
                <br />
                - السكري من النوع الثاني.
                <br />
                - مرض هشاشة العظام.
                <br />
                - النقرس.
                <br />
                - بعض أنواع السرطان.
                <br />
                - الربو.
                <br />
                - اضطرابات التنفس أثناء النوم (اعتلال التنفس أثناء النوم).
                <br />
                - مشاكل الخصوبة للرجال والنساء.
                <br />
                قد تكونان أيضًا عرضة لصعوبة في التنفس وآلام الظهر السفلي.
                البدانة يمكن أن تجعل أيضًا العمليات الجراحية وإجراء التخدير أكثر
                خطورة.
                <br />
                أما بالنسبة للوزن النقصي، فقد يكون سببه عدم الحصول على ما يكفي
                من العناصر الغذائية الصحيحة في النظام الغذائي. يمكن أيضًا أن
                يزيد هذا الوزن النقصي من خطر الإصابة ببعض مشاكل الصحة مثل:
                <br />
                - ضعف العضلات.
                <br />
                - زيادة خطر الإصابة بأمراض والعدوى.
                <br />
                - زيادة خطر بعض حالات القلب.
                <br />
                - مشاكل في الخصوبة.
                <br />
                - بطء في عملية التئام الجروح.
                <br />
                الالتزام بالوزن الصحي سيقلل من فرص تطوير هذه المشاكل الصحية.
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default IdealWeightCalculator;
